import React, { FC } from 'react'
import Player from '@bt-react/components/Player'
import Screen from '../../Screen'
import ScreenRowLayout from '../../Screen/ScreenRowLayout'
import { StreamScreenProps } from './types'
import styles from './StreamScreen.module.scss'
import StreamControl from '../StreamControl'
import classnames from 'classnames'

const StreamScreen: FC<StreamScreenProps> = ({ videoSourceUrl, isBridgeInstance, isMuted }) =>
  <Screen>
    <ScreenRowLayout>
      <div
        data-bdd='stream-screen'
        className={classnames(styles['stream-screen'], {
          [styles['stream-screen--hide-controls']]: isBridgeInstance
        })}
      >
        <div className={styles['stream-screen-player']}>
          <Player
            muteAudio={isMuted}
            controlsVisible={false}
            disablePause={true}
            source={videoSourceUrl}
          />
        </div>
        {
          !isBridgeInstance &&
          <div className={styles['stream-screen-controls']}>
            <StreamControl />
          </div>
        }
      </div>
    </ScreenRowLayout>
  </Screen>

export default StreamScreen